// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"zp-z","trustedRetailerTooltipWrapper":"Ap-z"};